<style scoped="scoped" lang="scss">
/deep/ .el-dialog .el-dialog__body {
  //max-height: calc(86vh - 112px);
  padding: 0 0 40px 66px;
}

.efficiency-details {
  .panel {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    background: #f7f8fa;
    color: #909399;
    height: 28px;
    line-height: 28px;
    // min-width: 1000px;
    width: 100%;
    flex-shrink: 0;

    // 效率信息说明
    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      background: #f7f8fa;
      color: #909399;
      height: 28px;
      line-height: 28px;
      // min-width: 1000px;
      width: 100%;
      flex-shrink: 0;

      .info-item-1 {
        max-width: 300px;
        min-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-2 {
        max-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-3 {
        width: 100%;
        text-align: right;
        color: #419fff;
      }
    }
  }

  // 效率表单
  .form {
    margin-top: 12px;

    // 标记点
    .percent-box {
      margin-top: 8px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      min-width: 1000px;
      flex-wrap: wrap;

      .percent-input {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
      }

      .percent-input1 {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin-left: 35px;
      }

      .border {
        // border: 1px solid #E5E5E5;
        width: 60px;
        height: 28px;
        border-radius: 5px;
        margin-left: 12px;
        text-align: center;
      }

      .mark {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
      }

      .border:focus {
        outline: none;
        border: 1px solid rgb(65, 159, 255);
      }

      .text-word {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
        margin-left: 26px;
      }

      .percent {
        display: flex;
        flex-wrap: nowrap;
        color: #4d4d4d;
        margin-left: 12px;
      }
    }
  }

  // 详细指标
  .detail-target {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        //margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  // 图表和表格
  .echart-table {
    margin-top: 8px;
    margin-bottom: 119px;
  }
}
</style>
<style lang="scss">
.el-transfer-panel__item.el-checkbox {
  margin-right: 0;
}
</style>
<template>
  <div class="efficiency-details">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"> </yi_curd_table>
    <!-- 信息说明 -->
    <div class="panel">
      <div class="info">
        <div class="info-item-1"></div>
        <div class="info-item-2"></div>
        <div class="info-item-3">
          {{ $t('meiri9:00gengxinzuorishuju') }}
        </div>
      </div>
    </div>
    <!-- 表单 -->
    <div class="form">
      <div ref="search1">
        <el-form :model="efficiencyDetails.searchForm" :inline="true" size="mini">
          <el-form-item :label="$t('xuanzeshijian')">
            <yi_time_input :format="'yyyy-MM-dd'" :maxTime="90 * 24 * 3600 * 1000" type="daterange" :start.sync="efficiencyDetails.searchForm.startTime" :end.sync="efficiencyDetails.searchForm.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="efficiencyDetails.searchForm.orgId" :ids.sync="efficiencyDetails.searchForm.orgIds" @change="listByOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="efficiencyDetails.searchForm.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('banci')">
            <el-select multiple v-model="efficiencyDetails.searchForm.shiftId" :placeholder="$t('qingxuanze')" clearable filterable :disabled="efficiencyDetails.searchForm.orgId.length === 0">
              <el-option v-for="item in shiftList" :key="item.id" :label="item.name + ' (' + item.code + ')'" :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.code }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEfficiencyDetails" plain>{{ $t('sousuo') }} </el-button>
            <el-button type="default" @click="reset" plain style="margin-left: 10px;">
              {{ $t('chongzhi') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="detail-target">
      <div class="left">
        <!--        <span class="icon"></span>-->
        <!--        <span class="txt">{{$t('xiaolumingxi')}}</span>-->
        <span class="txt">
          <!--          <el-button type="primary" size="mini"  @click="setUp" plain>{{$t('shaixuanshebei')}}</el-button>-->
        </span>
      </div>
      <div class="right">
        <!-- 效率明细导出 -->
        <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportEfficiencyDetailsExcel()"> </el-button>
        <el-button size="mini" type="default" @click="showShowTableColumn('efficiencyDetails')">
          <i class="yicon yicon-config_column"></i>
        </el-button>
      </div>
    </div>
    <!-- 效率明细表格 -->
    <div class="echart-table">
      <div class="table">
        <el-table stripe max-height="600" :data="efficiencyDetails.tableData" size="mini" border style="width: 100%" v-loading="searchLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" @header-dragend="headerDragend" @sort-change="efficiencyDetailsSortChange">
          <el-table-column v-for="(item, index) in filterEfficiencyDetailsTableColumn" :key="index" :sort-method="(a, b) => sortMethod(a, b, item)" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width" :show-overflow-tooltip="true"> </el-table-column>
        </el-table>
        <div style="float: right; margin-top:8px">
          <el-pagination class="fy" layout="total,prev, pager, next,sizes" :current-page="efficiencyDetails.currentPage" @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :total="parseInt(efficiencyDetails.total)" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" background> </el-pagination>
        </div>
      </div>
    </div>
    <!-- 自定义显示项 -->
    <el-dialog :title="$t(showTableColumn.title)" :visible.sync="showTableColumn.dialog" width="720px">
      <!-- 效率明细 -->
      <template v-if="showTableColumn.type === 'efficiencyDetails'">
        <el-transfer
          ref="transfer"
          :titles="[$t('yincanglie'), $t('xianshilie')]"
          v-model="showTableColumn.efficiencyDetails.show"
          :format="{
            noChecked: '${total}',
            hasChecked: '${total}'
          }"
          :data="efficiencyDetails.tableColumn"
        >
          <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="drag($event, option)">
            <div>{{ $t(option.label) }}</div>
          </div>
          <!--					<span slot-scope="{ option }"> {{ $t(option.label) }}</span>-->
        </el-transfer>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import Sortable from 'sortablejs';

const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1);
const current = year + '-' + month;

const startTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01';
const endTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
export default {
  name: 'web_report_efficiency_report_shift_statistics',
  props: {
    selectEquipment: {
      type: Array,
      required: true
    }
  },
  components: {},
  data() {
    return {
      shiftList: [],
      searchLoading: false,
      exportLoading: false,
      show: true,
      activeName: 'three',
      fildIds: '',
      timer: null,
      aaa: true,
      draggingKey: '',
      // 效率明细
      efficiencyDetails: {
        searchForm: {
          equipmentId: [],
          orgId: [],
          startTime: new Date(startTime).getTime(),
          endTime: new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59).getTime(),
          shiftId: []
        },
        tableData: [],
        tableColumn: [
          {
            key: 0,
            prop: 'equipmentName',
            sortable: true,
            label: 'shebeimingcheng'
          },
          {
            key: 1,
            prop: 'orgName',
            sortable: true,
            label: 'suoshuzuzhi'
          },
          {
            key: 2,
            prop: 'summaryDate',
            sortable: true,
            label: 'riqi'
          },
          {
            key: 3,
            prop: 'shiftName',
            sortable: true,
            label: 'banci'
          },
          {
            key: 4,
            prop: 'startTime',
            sortable: true,
            label: 'bancikaishishijian'
          },
          {
            key: 5,
            prop: 'endTime',
            sortable: true,
            label: 'bancijieshushijian'
          },
          {
            key: 6,
            prop: 'runDuraLabel',
            sortable: false,
            label: 'yunxingshijian(xiaoshi)'
          },
          {
            key: 7,
            prop: 'idleDuraLabel',
            sortable: false,
            label: 'kongxianshijian(xiaoshi)'
          },
          {
            key: 8,
            prop: 'errorDuraLabel',
            sortable: false,
            label: 'guzhangshijian(xiaoshi)'
          },
          {
            key: 9,
            prop: 'shutdownDuraLabel',
            sortable: false,
            label: 'lixianshijian(xiaoshi)'
          }
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      // 显示项
      showTableColumn: {
        dialog: false,
        title: 'peizhixianshilie',
        type: 'equipmentProduction',
        // 效率明细
        efficiencyDetails: {
          show: [],
          initShow: []
        }
      }
    };
  },
  mounted() {
    this.utils.event_hub.$on('EFFICENCY_REPORT_RESIZE', () => {
      setTimeout(() => {
        this.getEfficiencyDetails();
      }, 300);
    });
  },
  computed: {
    filterEfficiencyDetailsTableColumn() {
      let tableColumn = [];
      for (let i = 0; i < this.efficiencyDetails.tableColumn.length; i++) {
        if (this.showTableColumn.efficiencyDetails.show.includes(this.efficiencyDetails.tableColumn[i]['key'])) {
          tableColumn.push(this.efficiencyDetails.tableColumn[i]);
        }
      }
      const name = 'mes_efficiency_report_three';
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (tableColumn.length > 0) {
        for (const i in tableColumn) {
          if (colwidths[this.$t(tableColumn[i]['label'])] !== undefined) {
            this.$set(tableColumn[i], 'width', colwidths[this.$t(tableColumn[i]['label'])]);
          }
        }
      }
      // console.log('aaaaaaa', tableColumn)
      return tableColumn;
    }
  },
  created() {
    const name = 'mes_efficiency_report_' + this.activeName;
    if (window.localStorage.getItem('colwidth_' + name)) {
      try {
        this.efficiencyDetails.tableColumn = JSON.parse(window.localStorage.getItem('colwidth_' + name));
      } catch (e) {
        window.localStorage.removeItem('colwidth_' + name);
        this.efficiencyDetails.tableColumn = this.columns.map(item => {
          return item.label;
        });
      }
    } else {
      this.efficiencyDetails.tableColumn = this.columns.map(item => {
        return item.label;
      });
    }
    if (window.localStorage.getItem('sort_' + name)) {
      let sort_str = window.localStorage.getItem('sort_' + name);
      let sort_arr = JSON.parse(sort_str);
      this.efficiencyDetailsSortChange({
        prop: sort_arr[0],
        order: sort_arr[1]
      });
    }
    setTimeout(() => {
      this.utils.event_hub.$on('EFFICENCY_REPORT_RESIZE', () => {
        this.getEfficiencyDetails();
      });

      this.getEfficiencyDetails();
    }, 300);
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  watch: {
    selectEquipment: {
      handler(n) {
        this.getEfficiencyDetails();
      },
      immediate: false,
      deep: true
    }
  },
  methods: {
    // 查询客户所属组织关联的班次列表
    listByOrgId() {
      if (this.efficiencyDetails.searchForm.orgId.length === 0) {
        return;
      }
      const orgId = this.efficiencyDetails.searchForm.orgId[0];
      this.http
        .get('/web/setting/shift/listByOrgId?orgId=' + orgId)
        .then(res => {
          this.shiftList = res.data || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    sortMethod(a, b, col) {
      // console.log('ffffffffffffffffffcol',col)
      return (a, b) => {
        let aValue = this.utils.getObjValueByLevelString(a, col.prop);
        let bValue = this.utils.getObjValueByLevelString(b, col.prop);
        if (col.sort == 'number') {
          return aValue - bValue;
        } else if (col.sort == 'datetime') {
          let reg1 = new RegExp(' ', 'g');
          let reg2 = new RegExp('-', 'g');
          let reg3 = new RegExp(':', 'g');
          return (
            aValue
              .replace(reg1, '')
              .replace(reg2, '')
              .replace(reg3, '') -
            bValue
              .replace(reg1, '')
              .replace(reg2, '')
              .replace(reg3, '')
          );
        } else {
          return (aValue + '').localeCompare(bValue + '') > 0 ? -1 : 1;
        }
      };
    },
    drag(ev, option) {
      this.draggingKey = option.key;
    },
    initColumnsTransfer() {
      const transfer = this.$refs.transfer.$el;
      const leftPanel = transfer.getElementsByClassName('el-transfer-panel')[0].getElementsByClassName('el-transfer-panel__body')[0];
      const rightPanel = transfer.getElementsByClassName('el-transfer-panel')[1].getElementsByClassName('el-transfer-panel__body')[0];
      const rightEl = rightPanel.getElementsByClassName('el-transfer-panel__list')[0];
      Sortable.create(rightEl, {
        animation: 100,
        onEnd: evt => {
          const { oldIndex, newIndex } = evt;
          const temp = this.efficiencyDetails.tableColumn[oldIndex];
          if (!temp || temp === 'undefined') {
            return;
          } // 解决右边最后一项从右边拖左边，有undefined的问题
          //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
          //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
          //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
          // 去除空字符串
          for (var i = 0; i < this.efficiencyDetails.tableColumn.length; i++) {
            if (this.efficiencyDetails.tableColumn[i] === '' || this.efficiencyDetails.tableColumn[i] === null || typeof this.efficiencyDetails.tableColumn[i] === 'undefined') {
              this.efficiencyDetails.tableColumn.splice(i, 1);
              i = i - 1;
            }
          }
          const arr_temp = [].concat(this.efficiencyDetails.tableColumn); // 创建一个新的临时数组，用以操作后不变更原数组
          arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素
          this.efficiencyDetails.tableColumn = arr_temp;
          console.log(this.efficiencyDetails.tableColumn);

          //保存
          this.showColumnsChange();
        }
      });
      const leftEl = leftPanel.getElementsByClassName('el-transfer-panel__list')[0];
      Sortable.create(leftEl, {
        animation: 100,
        onEnd: evt => {
          const { oldIndex, newIndex } = evt;
          const temp = this.datas[oldIndex];
          this.$set(this.datas, oldIndex, this.datas[newIndex]);
          this.$set(this.datas, newIndex, temp);
        }
      });
      leftPanel.ondragover = ev => {
        ev.preventDefault();
      };
      leftPanel.ondrop = ev => {
        ev.preventDefault();
        const index = this.efficiencyDetails.tableColumn.indexOf(this.draggingKey);
        if (index !== -1) {
          this.efficiencyDetails.tableColumn.splice(index, 1);
        }
      };
      rightPanel.ondragover = ev => {
        ev.preventDefault();
      };
      rightPanel.ondrop = ev => {
        ev.preventDefault();
        if (this.efficiencyDetails.tableColumn.indexOf(this.draggingKey) === -1) {
          this.efficiencyDetails.tableColumn.push(this.draggingKey);
        }
      };
    },
    showColumnsChange() {
      const name = 'mes_efficiency_report_' + this.activeName;
      //保存
      window.localStorage.setItem('colwidth_' + name, JSON.stringify(this.efficiencyDetails.tableColumn));
    },
    // 效率明细
    async getEfficiencyDetails(orderKey, orderRule) {
      if (!this.efficiencyDetails.searchForm.startTime || !this.efficiencyDetails.searchForm.endTime) {
        this.$message.error(this.$t('xuanzeshijianbitian'));
        return;
      }
      this.searchLoading = true;
      let requestParam = {};
      let param = [];

      for (let i = 0; i < this.efficiencyDetails.tableColumn.length; i++) {
        this.showTableColumn.efficiencyDetails.show.push(i);
      }
      this.showTableColumn.efficiencyDetails.initShow = [...this.showTableColumn.efficiencyDetails.show];
      const str = this.selectEquipment.join(',');
      for (let i in this.efficiencyDetails.searchForm) {
        if (this.efficiencyDetails.searchForm[i] != '' && this.efficiencyDetails.searchForm[i] != null) {
          let val = this.efficiencyDetails.searchForm[i];
          if (i === 'equipmentId') {
            val = this.efficiencyDetails.searchForm[i].join(',');

            param.push({
              field: 'equipmentId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i === 'orgId') {
            val = this.efficiencyDetails.searchForm[i].join(',');
            param.push({
              field: 'orgId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i === 'startTime') {
            val = this.efficiencyDetails.searchForm[i];
            param.push({
              field: 'summaryDate',
              opt: '>=',
              val: val,
              type: 'D'
            });
          }

          if (i === 'endTime') {
            val = this.efficiencyDetails.searchForm[i];
            param.push({
              field: 'summaryDate',
              opt: '<',
              val: val,
              type: 'D'
            });
          }
          if (i == 'shiftId') {
            val = this.efficiencyDetails.searchForm[i].join(',');
            param.push({
              field: i,
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
        }
      }
      if (param.length > 0) {
        requestParam['columns'] = param;
      } else {
        requestParam['columns'] = [];
      }
      let pageParam = {
        pageSize: this.efficiencyDetails.pageSize,
        pageNum: this.efficiencyDetails.currentPage,
        // equipmentId: str,
        orderBy: 'sort,startTime asc'
        // summaryDate: 'summaryDate'
      };
      if (orderRule !== null && orderRule !== undefined) {
        pageParam['orderBy'] = orderRule === 'ascending' ? orderKey + ' asc' : orderKey + ' desc';
      }
      requestParam['code'] = 'equipment_basic_efficiency';
      let response = await this.http.post('/web/report/page?' + this.qs.stringify(pageParam), requestParam);
      this.efficiencyDetails.tableData = response.data.rows || [];

      this.efficiencyDetails.total = response.data.total;
      if (this.efficiencyDetails.tableData.length > 0) {
        for (let i = 0; i < this.efficiencyDetails.tableData.length; i++) {
          this.efficiencyDetails.tableData[i]['runDuraLabel'] = (this.efficiencyDetails.tableData[i]['runDuration'] / 1000 / 3600).toFixed(1);
          this.efficiencyDetails.tableData[i]['idleDuraLabel'] = (this.efficiencyDetails.tableData[i]['idleDuration'] / 1000 / 3600).toFixed(1);
          this.efficiencyDetails.tableData[i]['errorDuraLabel'] = (this.efficiencyDetails.tableData[i]['errorDuration'] / 1000 / 3600).toFixed(1);
          this.efficiencyDetails.tableData[i]['shutdownDuraLabel'] = (this.efficiencyDetails.tableData[i]['shutdownDuration'] / 1000 / 3600).toFixed(1);
          this.efficiencyDetails.tableData[i]['summaryDate'] = this.efficiencyDetails.tableData[i]['summaryDate'] == null ? '' : this.dateItemFormat(this.efficiencyDetails.tableData[i]['summaryDate']);
          this.efficiencyDetails.tableData[i]['startTime'] = this.efficiencyDetails.tableData[i]['startTime'] == null ? '' : this.dateFormat(this.efficiencyDetails.tableData[i]['startTime']);
          this.efficiencyDetails.tableData[i]['endTime'] = this.efficiencyDetails.tableData[i]['endTime'] == null ? '' : this.dateFormat(this.efficiencyDetails.tableData[i]['endTime']);
        }
      }
      this.searchLoading = false;
    },
    // 效率明细导出
    exportEfficiencyDetailsExcel() {
      this.exportLoading = true;
      let requestParam = {};
      let param = [];

      for (let i in this.efficiencyDetails.searchForm) {
        if (this.efficiencyDetails.searchForm[i] != '') {
          let val = this.efficiencyDetails.searchForm[i];
          if (i === 'equipmentId') {
            val = this.efficiencyDetails.searchForm[i].join(',');
            param.push({
              field: 'equipmentId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i === 'orgId') {
            val = this.efficiencyDetails.searchForm[i].join(',');
            param.push({
              field: 'orgId',
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
          if (i === 'startTime') {
            console.log(this.efficiencyDetails.searchForm[i]);
            val = this.efficiencyDetails.searchForm[i];
            param.push({
              field: 'summaryDate',
              opt: '>=',
              val: val,
              type: 'D'
            });
          }
          if (i === 'endTime') {
            val = this.efficiencyDetails.searchForm[i];
            param.push({
              field: 'summaryDate',
              opt: '<',
              val: val,
              type: 'D'
            });
          }
          if (i == 'shiftId') {
            val = this.efficiencyDetails.searchForm[i].join(',');
            param.push({
              field: i,
              opt: 'IN',
              val: val,
              type: 'S'
            });
          }
        }
      }

      if (param.length > 0) {
        requestParam['columns'] = param;
      } else {
        requestParam['columns'] = [];
      }
      requestParam['code'] = 'equipment_basic_efficiency_details_export';
      return this.http
        .post('/web/report/export?orderBy=sort,shiftName,startTime asc', requestParam)
        .then(response => {
          let fildId = response.data;
          return this.http
            .get('/web/report/work/get', {
              params: {
                id: fildId
              }
            })
            .then(response => {
              this.fildIds = response.data.fileId;
              console.log('response.msg1', response.data.status);
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            })
            .finally(() => {
              this.exportLoading = false;
            });
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log('this.fildIdthis.fildId', this.fildIds);
      return this.http.get('/web/customer/files/download?id=' + this.fildIds).then(res => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    // 效率明细条数切换
    handleSizeChange(value) {
      this.efficiencyDetails.pageSize = value;
      this.getEfficiencyDetails();
    },
    // 重置效率明细
    reset() {
      this.efficiencyDetails.searchForm = {
        equipmentId: null,
        orgId: null,
        // summaryDate: [startTime, endTime]
        startTime: new Date(startTime).getTime(),
        endTime: new Date(endTime).getTime()
      };
      this.efficiencyDetails.currentPage = 1;
      this.getEfficiencyDetails();
    },
    // 效率明细分页
    handleCurrentChange(value) {
      this.efficiencyDetails.currentPage = value;
      this.getEfficiencyDetails();
    },
    efficiencyDetailsSortChange({ column, prop, order }) {
      this.getEfficiencyDetails(prop, order);
    },
    headerDragend(newWidth, oldWidth, column, event) {
      const name = 'mes_efficiency_report_' + this.activeName;
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.label == '' || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem('colwidth_' + name, JSON.stringify(colwidths));
      this.aaa = !this.aaa;
    },
    // 显示选择项
    showShowTableColumn(type) {
      this.showTableColumn.type = type;
      this.showTableColumn.dialog = true;
      this.$nextTick(() => {
        this.initColumnsTransfer();
      });
    },

    // 取消选择项
    cancelShowTableColumn() {
      this.showTableColumn.show = [...this.showTableColumn.initShow];
      this.showTableColumn.dialog = false;
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d h:i:s';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    },
    dateItemFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = 'Y-m-d';
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      // let hours = t.getHours()
      // let minutes = t.getMinutes()
      // let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      // hours = hours > 9 ? hours : `0${hours}`
      // minutes = minutes > 9 ? minutes : `0${minutes}`
      // seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        Y: year,
        m: month,
        d: day
      };
      return format.replace(/\w/g, o => {
        return hash[o];
      });
    }
  }
};
</script>
